import { Button, Dropdown } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Avatar, Badge, ConfigProvider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT_SUCCESS, SET_APP_SETTING, SET_EVENTS, SET_PAST_EVENTS } from "../redux/actions/action";
import cart from "../assets/cart.svg";
import searchicon from "../assets/search.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import newLogo from "../assets/image/Dreamland_logo.webp";
import secondLogo from "../assets/image/dle_logo.webp";
import MainRoutes from "./routes";
import Footer from "./Footer";
import { getAppSettings, getSearchEvent } from "../api/api";
import { MAIN_API } from "../api/apilist";
import { useMediaQuery } from "react-responsive";
import PopupModel from "./popupmodel";
import WhatsAppWidget from "../components/WhatsAppWidget";

const AppRouter = () => {
  const [activelink, setActiveLink] = useState("");
  const [expanded, setExpanded] = useState(false);
  const auth = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [appSettings, setAppSettings] = useState({});
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const fetchAppSettings = async () => {
    try {
      const response = await getAppSettings();
      if (response.status === 200) {
        setAppSettings(response.data.info);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const preloadEvents = async () => {
    try {
      // Preload Upcoming Events
      const upcomingRes = await getSearchEvent({ sort: "Upcoming Events" }, 1);
      if (upcomingRes.status === 200) {
        dispatch({ type: SET_EVENTS, payload: upcomingRes.data.info });
      }
      
      // Preload Past Events in background too
      const pastRes = await getSearchEvent({ sort: "Past Events" }, 1);
      if (pastRes.status === 200) {
        dispatch({ type: SET_PAST_EVENTS, payload: pastRes.data.info });
      }
    } catch (error) {
      console.error("Background preload error:", error);
    }
  };
  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    fetchAppSettings();
    const preloadTimer = setTimeout(() => {
      preloadEvents();
    }, 3000);
    return () => clearTimeout(preloadTimer);
  }, []);

  // Prevent background scroll when mobile nav is open
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    
    if (expanded) {
      html.classList.add("no-scroll");
      body.classList.add("no-scroll");
    } else {
      html.classList.remove("no-scroll");
      body.classList.remove("no-scroll");
    }
    
    // Cleanup
    return () => {
      html.classList.remove("no-scroll");
      body.classList.remove("no-scroll");
    };
  }, [expanded]);

  const handleScrollTo = (id) => {
    setExpanded(false);
    
    const performScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        // Use a slightly more robust scroll approach
        const offset = 80; // Account for fixed header
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = el.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    };

    if (location.pathname !== "/") {
      navigate("/");
      // Longer delay when navigating from another page to allow home content to load
      setTimeout(performScroll, 1200);
    } else {
      // Delay to allow offcanvas to close and layout to settle
      setTimeout(performScroll, 800);
    }
  };

  return (
    <>
      <Navbar 
        key="md" 
        expand="md" 
        variant="light" 
        style={{ height: "75px", backgroundColor: "#FFFFFF", boxShadow: "0 2px 12px rgba(13,38,60,0.06)" }} 
        className="pading150"
        expanded={expanded}
        onToggle={setExpanded}
      >
        <Container fluid style={{ padding: "0px !important" }}>
          <Navbar.Brand as="a" onClick={() => { navigate("/"); setExpanded(false); }} style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: isMobile ? "6px" : "10px" }}>
            <img 
              src={appSettings.logo 
                ? (appSettings.logo.startsWith('http') ? appSettings.logo : `${MAIN_API}/${appSettings.logo}`) 
                : newLogo
              } 
              alt="logo" 
              style={{ height: isMobile ? "55px" : "55px", maxWidth: isMobile ? "160px" : "160px", objectFit: "contain" }} 
            />
            <div style={{ height: isMobile ? "20px" : "30px", width: "1.5px", backgroundColor: "#0D263C", opacity: "0.2" }}></div>
            <img 
              src={secondLogo.startsWith('data:') ? secondLogo : `${window.location.origin}${secondLogo}`} 
              alt="secondary logo" 
              style={{ height: isMobile ? "55px" : "55px", maxWidth: isMobile ? "160px" : "160px", objectFit: "contain" }} 
            />
          </Navbar.Brand>
          <div style={{ display: "flex" }}>
            <img
              src={searchicon}
              alt="search"
              className="sercheicon"
              style={{ marginRight: "4px" }}
              onClick={() => navigate("/search")}
            />
            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-md" style={{ border: "none", padding: "0" }}>
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </Navbar.Toggle>
          </div>
          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-md"
            aria-labelledby="offcanvasNavbarLabel-expand-md"
            placement="end"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-md">
                <div className="offcanvas-logo-wrapper" onClick={() => { navigate("/"); setExpanded(false); }}>
                  <img 
                    src={appSettings.logo 
                      ? (appSettings.logo.startsWith('http') ? appSettings.logo : `${MAIN_API}/${appSettings.logo}`) 
                      : newLogo
                    } 
                    alt="Dreamland Entertainment" 
                    className="offcanvas-logo"
                  />
                  <div className="offcanvas-logo-divider"></div>
                  <img 
                    src={secondLogo} 
                    alt="DLE" 
                    className="offcanvas-logo"
                  />
                </div>
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="flex justify-content-between">
              <Nav className={`${isMobile ? "justify-content-start pt-4" : "justify-content-center"} flex-grow-1 pe-3`}>
                <Nav.Link
                  style={{ cursor: "pointer" }}
                  as="a"
                  onClick={() => {
                    navigate("/");
                    setExpanded(false);
                  }}
                  active={activelink === "/"}
                >
                  Home
                </Nav.Link>
                <NavDropdown
                  title="Events"
                  id="events-nav-dropdown"
                  className={`events-nav-dropdown ${activelink.startsWith("/event") || activelink.startsWith("/past-event") ? "active-dropdown" : ""}`}
                  renderMenuOnMount={true}
                >
                  <NavDropdown.Item onClick={() => { navigate("/event"); setExpanded(false); }} active={activelink === "/event"}>
                    Events
                  </NavDropdown.Item>
                  <NavDropdown.Item onClick={() => { navigate("/past-event"); setExpanded(false); }} active={activelink === "/past-event"}>
                    Past Events
                  </NavDropdown.Item>
                </NavDropdown>
                <Nav.Link
                  style={{ cursor: "pointer" }}
                  as="a"
                  onClick={() => handleScrollTo("newhome-performers-divider")}
                >
                  Performers
                </Nav.Link>
                <Nav.Link
                  style={{ cursor: "pointer" }}
                  as="a"
                  onClick={() => handleScrollTo("newhome-highlights")}
                >
                  Facilities
                </Nav.Link>
                {auth.isAuthenticated && (
                  <Nav.Link
                    style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
                    as="a"
                    onClick={() => {
                      navigate("/eventhistory");
                      setExpanded(false);
                    }}
                    className="searchlink"
                    active={activelink.startsWith("/eventhistory")}
                  >
                    <svg className="ticket-icon-animate" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: "10px" }}>
                      <path d="M15 5v2"></path>
                      <path d="M15 11v2"></path>
                      <path d="M15 17v2"></path>
                      <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z"></path>
                    </svg>
                    Event History
                  </Nav.Link>
                )}
              </Nav>

              <Nav className={`align-items-center ${isMobile ? "mt-4 pb-4" : ""}`}>
                {auth.isAuthenticated && !isMobile && (
                  <Nav.Link
                    style={{ cursor: "pointer", color: "#000", padding: "8px" }}
                    onClick={() => navigate("/eventhistory")}
                    title="Event History"
                  >
                    <svg className="ticket-icon-animate" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M15 5v2"></path>
                      <path d="M15 11v2"></path>
                      <path d="M15 17v2"></path>
                      <path d="M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3a2 2 0 0 0 0-4V7a2 2 0 0 1 2-2z"></path>
                    </svg>
                  </Nav.Link>
                )}
                <Nav.Link as="a" style={{ cursor: "pointer", display: "flex", flexDirection: isMobile ? "column" : "row", alignItems: "center", gap: "10px", padding: isMobile ? "10px 0" : "0" }}>
                  <Button
                    className="fs-6 fw-semibold"
                    style={{ backgroundColor: "#0D263C", border: "none", width: isMobile ? "100%" : "130px", borderRadius: "8px" }}
                    onClick={() => handleScrollTo("newhome-pricing-grid")}
                  >
                    Book Now
                  </Button>
                  {auth.isAuthenticated ? (
                    <Dropdown className="myaccountdropdown" style={{ width: isMobile ? "100%" : "auto" }}>
                      <Dropdown.Toggle
                        style={{
                          backgroundColor: "#EC6325",
                          fontSize: "14px",
                          fontWeight: "600",
                          border: "none",
                          width: isMobile ? "100%" : "140px",
                        }}
                        id="dropdown-basic"
                      >
                        My Account
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="myaccountdropdownmenu">
                        <Dropdown.Item style={{ cursor: "auto" }}>{auth.user.name}</Dropdown.Item>
                        <Dropdown.Item onClick={() => { navigate("/eventhistory"); setExpanded(false); }}>Event History</Dropdown.Item>
                        <Dropdown.Item onClick={() => { dispatch({ type: LOGOUT_SUCCESS }); setExpanded(false); }}>Log out</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    <Button
                      className="fs-6 fw-semibold"
                      style={{ backgroundColor: "#EC6325", border: "none", width: isMobile ? "100%" : "120px" }}
                      onClick={() => {
                        navigate("/login");
                        setExpanded(false);
                      }}
                    >
                      Login
                    </Button>
                  )}
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
        <PopupModel />
      </Navbar>
      <MainRoutes />
      <Footer />
      {!expanded && <WhatsAppWidget />}
    </>
  );
};

export default AppRouter;
